<script lang="ts">
    import LL from "../../../i18n/i18n-svelte";
    import ToastContainer from "./ToastContainer.svelte";
    import { IconNetworkOff } from "@wa-icons";

    export let toastUuid = "";
</script>

<ToastContainer theme="secondary" extraClasses="w-full min-w-72 max-w-sm sm:min-w-80 sm:max-w-md" {toastUuid}>
    <div class="flex items-center gap-3 text-left" data-testid="websocket-reconnecting-toast">
        <div class="relative flex h-8 w-8 shrink-0 items-center justify-center">
            <IconNetworkOff class="text-mdark" font-size="1.35rem" />
        </div>
        <div class="flex min-w-0 flex-col">
            <p class="m-0 text-sm font-bold leading-snug text-mdark">{$LL.warning.connectionLostTitle()}</p>
            <p class="m-0 text-xs leading-snug text-mdark/80">{$LL.messageScreen.connecting()}</p>
        </div>
    </div>
</ToastContainer>
